import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M93.566 88.004a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M101.5 33.838a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M16.415 53.258a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M17.62 68.006a1.5 1.5 0 0 1 0 2.121L7.627 80.12A1.5 1.5 0 1 1 5.505 78l9.994-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M5.505 68.006a1.5 1.5 0 0 1 2.122 0l9.994 9.993a1.5 1.5 0 1 1-2.122 2.121l-9.994-9.993a1.5 1.5 0 0 1 0-2.121M105.633 43.938a1.5 1.5 0 0 1 1.5 1.5V59.57a1.5 1.5 0 0 1-3 0V45.438a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M97.066 52.504a1.5 1.5 0 0 1 1.5-1.5H112.7a1.5 1.5 0 0 1 0 3H98.566a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M57.996 26a31.603 31.603 0 0 0-26.879 48.302L24.22 88.79c-.8 1.68.954 3.433 2.634 2.633l14.487-6.9c13.446 8.363 31.39 5.645 41.703-7.424 5.064-6.417 7.422-14.7 6.498-22.823C87.66 37.732 73.834 25.97 57.997 26"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M44.32 49.602a2.25 2.25 0 0 1 2.25-2.25h24.836a2.25 2.25 0 1 1 0 4.5H46.57a2.25 2.25 0 0 1-2.25-2.25M44.32 62.987a2.25 2.25 0 0 1 2.25-2.25h18.084a2.25 2.25 0 1 1 0 4.5H46.57a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCommentsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCommentsBrand);
export default Memo;
